__turbopack_context__.v({
  "salesEndedMessage": "SalesEndedMessage-module-scss-module__aN_G_q__salesEndedMessage",
  "salesEndedMessageBody": "SalesEndedMessage-module-scss-module__aN_G_q__salesEndedMessageBody",
  "salesEndedMessageHeader": "SalesEndedMessage-module-scss-module__aN_G_q__salesEndedMessageHeader",
  "salesEndedMessageHeaderRow": "SalesEndedMessage-module-scss-module__aN_G_q__salesEndedMessageHeaderRow",
  "salesEndedMessageIcon": "SalesEndedMessage-module-scss-module__aN_G_q__salesEndedMessageIcon",
});
